module.exports = __webpack_public_path__ + "static/monitora2-00957f371c1ee706c1588b3f370a8a07.png";